export default {
    payment_failed_please_contact_admin: "Votre paiement n'a pas pu être traité. Veuillez contacter le support.",
    login: "Connexion",
    forgot_password: "Mot de passe oublié ?",
    english: "English",
    german: "Deutsch",
    french: "Français",
    italian: "Italiano",
    dutch: "Nederlands",
    spanish: "Español",
    portuguese: "Português",
    english_short: "EN",
    german_short: "DE",
    french_short: "FR",
    italian_short: "IT",
    dutch_short: "NL",
    spanish_short: "ES",
    portuguese_short: "PT",
    no_more_photos_for_moderation: "Il n'y a plus d'images à modérer. Reviens un peu plus tard. Merci pour ton aide 😘",
    timezone: 'Fuseau horaire',
    timezone_type_automatic: 'Votre fuseau horaire sera détecté automatiquement',
    timezone_type_manually: 'Votre fuseau horaire choisi sera verrouillé',
    invalid_token_message: 'Pour des raisons de sécurité, votre jeton d’accès a expiré.\n' +
        'Veuillez demander un nouveau jeton pour continuer.',
    try_again:'Réessayer',
    add_links_to_profiles_events_clubs:'Ajoute des liens vers des profils, des événements et des clubs',
    you_can_add_only_twenty_links: 'Tu ne peux ajouter que 20 liens',
    enter_your_social_network_handle: 'Saisis ton identifiant {social_network}',
    follow: 'Suivre',
    message: 'Message',
    message_copied: 'Copié avec succès',
    copied_from_clipboard: 'Copied from clipboard',
    reply: "répondre",
    copy: "copier",
    delete_for_all: "supprimer pour tous",
    now: "MTN!",
    meet_now:"Rencontre MTN!",
    activate_meet_now:"Active \"MAINTENANT !\" et montre que tu es prêt(e) à rencontrer.",
    activate_now:"Active MAINTENANT !",
    deactivate_now:"Désactive MAINTENANT !",
    meet_now_mini_text:"„MAINTENANT !“ reste actif pendant 30 minutes.",
    finished:"Fini ?",
    over_now:"...fini MTN !",
    headline_or_nickname:"Titre ou Surnom",
    meet_now_upgrade_to_pro:"„MAINTENANT !“ a été activé {0} fois aujourd'hui. Passe à PRO pour réactiver „MAINTENANT !“ sans limite.",
    activate_meet_now_n_times:"Active \"MAINTENANT !\" jusqu'à {0} fois par jour. Les membres PRO peuvent activer sans limites.",

    email: "E-mail",
    email_or_username: "E-mail ou pseudo",
    photo: "Photo",
    password: "ton mot de passe",
    verify_age: 'Vérifier l\'âge',
    verifying_age: 'Vérification de l\'âge',
    verification_success_title: 'Vérification terminée',
    verification_success_desc: 'Votre âge a été vérifié avec succès.',
    verification_failed_title: 'Échec de la vérification',
    verification_failed_desc: 'La vérification n\'a pas réussi. Vous pouvez réessayer en sélectionnant ou en téléchargeant une autre photo.',
    verification_limit_title: 'Limite Atteinte',
    verification_limit_desc: 'Vous avez dépassé le nombre maximum de tentatives de vérification de l\'âge. Veuillez réessayer plus tard.',
    try_again_in: 'Réessayez dans',
    close: 'Fermer',
    okay: 'D\'accord',
    start_verification: 'lancer la vérification',
    choose_photo: 'Choisir une photo',
    age_verification_photo_instruction: 'Veuillez fournir une photo où votre visage est clairement visible. La photo ne doit contenir qu\'une seule personne.',
    age_verification_description: 'Pour vérifier votre âge, veuillez suivre les instructions.',
    verify_now: 'Vérifier maintenant',
    stay_logged_in: "Rester connecté ?",
    new_to_barebuddy: "Nouveau sur Buddy ?",
    join_now: "Rejoins-nous !",
    // what_is_barebuddy: "What is BareBuddy? Find out more",
    recover_password: "Récupérer mot de passe",
    reset_password: "Réinitialiser mot de passe",
    confirm_password: "Confirmer mot de passe",
    recover_now: "Récupérer maintenant",
    create: "Créer",
    start: "Commencer",
    age_modal:{
        'age_check' : 'Vérification d\'âge',
        'contain_sensitive_material':'Cette page peut contenir du contenu sensible.',
        'you_need_eighteen':'Tu dois avoir plus de 18 ans pour continuer.',
    },
    join_modal:{
        become_a_member: "Deviens membre maintenant et profite de toutes les fonctionnalités.",
        its_quick_and_free: "C'est rapide et gratuit !",
        already_a_member:"Déjà membre ?",
    },
    passwords: {
        password: "Les mots de passe doivent comporter au moins six caractères et correspondre à la confirmation.",
        reset: "Ton mot de passe a été réinitialisé !",
        sent: "Si cet e-mail est enregistré, tu recevras un lien de récupération.",
        token: "Ce lien de réinitialisation de mot de passe est invalide.",
        user: "Si cet e-mail est enregistré, tu recevras un lien de récupération.",
    },
    welcome: {
        what_next: "Que veux-tu faire ensuite?",
        nickname: "Surnom",
        nickname_description: "Complète ton profil maintenant.",
        discover: "Découvre BUDDY",
        discover_description: "Chat, Rendez-vous, Chill, Guide et bien plus encore à découvrir.",
        pro: "Passer à Pro",
        pro_description: "Du plaisir infini avec la version Pro."
    },
    invalid_credentials: "Les informations d'identification sont incorrectes.",
    reg: {
        // step1: "Step 1",
        // step2: "Step 2",
        // step3: "Step 3",
        ready: "Prêt",
        automatic_location: "Localisation automatique",
        manual_location: "Localisation manuelle",
        location_defining: "Définition de l'emplacement...",
        choose_password: 'Choisis un mot de passe',
        password_looks_good: "Ton mot de passe a l'air bien.",
        pick_nickname: "Écris un surnom pour ton profil Buddy.",
        nickname: "Pseudo",
        pick_handle: "Voici ton lien Buddy :",
        suggestions: 'Suggestions',
        handle_already_taken : "Ce lien Buddy est déjà pris.",
        password_description: "votre mot de passe doit être min. 6 caractères",
        handle_available: "Le lien Buddy est disponible.",
        handle_description : "Ton lien Buddy aide les autres à trouver ton profil. Tu peux le changer maintenant ou plus tard dans les paramètres.",
        birthdate: "Date de naissance",
        next: "Continuer",
        upload_photo: "Télécharger la photo",
        enter_email_address: "Ton e-mail",
        almost_finished: "Presque terminé...",
        add_photo_text: "Ajoute une photo pour que\n" +
            "les buddies puissent te voir.",
        i_am_ready: "Je suis Prêt",
        skip: "Sauter",
        back: "RETOUR",
        add_photo: "Ajouter une Photo",
        you_made_it: "C'est terminé !",
        accept_terms_privacy_text: "En cliquant sur \"Continuer\", je garantis que j'ai 18 ans ou plus et que j'ai lu la {0} et accepté les {1}.",
        accept_terms_privacy_text_barebuddy: "By entering, you agree to our {0} and {1}.",
        terms_of_service: "Terms of Service",
        you_must_be_eighteen: "You must be over 18 years old to enter",
        terms_of_use: "conditions d'utilisation",
        privacy_policy: "politique de confidentialité",
        finish: "Terminer",
        cancel: "Annuler",
        upload: "Télécharger",
        welcome_to_bb: "Bienvenue sur BUDDY",
        where_are_you_located: "Où habites-tu ?",
        use_current_location: "Utiliser ma position actuelle",
        choose_location_manually: "Choisir ma position manuellement",
        lets_go: "Prêt",
        human_verification_required: "Complète le Captcha pour continuer",
        try_another_photo: "Essayer une autre photo",
        map: "Carte",
        use_gps: "Utiliser GPS",
        gps: "GPS",
        type_address: "Renseigne ton Adresse",
    },
    links: {
        about_us: "À propos",
        imprint: "Impressum",
        support: "Support",
        terms: "Conditions d'utilisation",
        community_guidelines: "Règles de la communauté",
        privacy: "Déclaration de confidentialité",
        billing_support: "Support facturation",
    },
    profile_preview: 'Aperçu du profil',
    public_gallery: 'Galerie publique',
    nearby: "À proximité",
    recent: "Récent",
    shuffle: "Shuffle",
    favorites: "Favoris",
    favorites_online: "Favoris en ligne",
    online: "En ligne",
    send_photo: "Envoyer Photo",
    send_location: "Envoyer Position",
    set_location: "Choisir Position",
    type_something: "Tape quelque chose",
    all: "Tous",
    unread: "Non lus",
    pos_of_total: " {position} sur {total}'",
    block_user: "Bloquer utilisateur",
    report_user: "Signaler utilisateur",
    user_not_found: 'Utilisateur non trouvé',
    cancel: "Annuler",
    online_now: "En ligne",
    away: "En ligne récemment",
    offline: "Absent",
    about: "À propos",
    height: "Taille",
    weight: "Poids",
    body: "Corps",
    position: "Position",
    penis: "Bite",
    hiv: "Status",
    drugs: "Candy",
    info: "Infos",
    stats: "Profil",
    photos: "Photos",
    settings: "Paramètres",
    share: "Partager",

    open_mailbox: 'Ouvrir la messagerie',

    about_me: "À propos de moi",
    tags: "Tags",
    access: "Accès",
    profile_account: "Compte",
    account: "Compte",
    logout: "Déconnexion",
    preferences: "Préférences",
    show_age: "Afficher âge",
    yes: "Oui",
    no: "Non",
    join: "Rejoindre",
    host: "Hôte",
    member: "Membre",
    language: "Langue",
    unit_system: "Système d'unités",
    metric: "Métrique",
    imperial: "Impérial",
    website_design: "Design du site web",
    old: "Ancien",
    reset: "Réinitialiser",
    unblock_users: "Débloquer utilisateurs",
    delete_my_profile: "Supprimer mon profil",
    your_profile_picture: "Image de profil",
    public_pictures: "Images publiques",
    can_select_count: "{count}/{total}",
    make_photo_private: "Rendre photo privée",
    make_photo_public: "Rendre photo publique",
    set_profile_picture: "Choisir comme image de profil",
    delete_photo: "Supprimer photo",
    display_name: "Pseudo",
    display_link : 'Buddy link',
    display_club_link_or_title: 'clublink or title',
    location: "Position",
    support: "Support",
    photo_message: "Message avec photo",
    distance_away: "à {distance}",
    set_current_location: "Choisir position actuelle",
    location_message: "Message de position",
    no_users_around: "Il n'y a aucun Buddy autour de toi",
    no_more_users_around: "Il n'y a pas d'autre Buddy autour de toi",
    to_see_members_become_a_member: 'Pour voir plus d\'utilisateurs, deviens membre.',
    no_chat_messages: "Historique de chat vide",
    no_more_chat_messages: "Il n'y a pas d'autre message dans l'historique de chat",
    message_not_delivered: "pas livré - tape pour envoyer de nouveau",
    old_password: "Ancien mot de passe",
    new_password: "Nouveau mot de passe",
    new_password_confirmation: "Répéter mot de passe",
    password_modified: "Ton mot de passe a bien été modifié !",
    wrong_old_password: "L'ancien mot de passe est incorrect",
    save: "Sauver",
    are_you_sure_delete_profile: "Es-tu sûr de vouloir supprimer ton profil ??",
    all_users_unblocked: "Tous les utilisateurs ont bien été débloqués",
    no_tags: "ajoute tes tags ici",
    add_tag: "écris un unique tag et appuie sur la touche Entrée",
    link_copied: "Lien copié",

    write_us_help: "Écris-nous pour obtenir de l'Aide, des Suggestions et plus encore ",
    automatic_location: "Détection automatique",
    manual_location: "Choisir position manuelle",
    address: "Adresse",
    fail_load_location: "Impossible d'accéder à ta position. Veux-tu indiquer ta position manuellement ?",
    fail_auto_choose_manual_location: "Impossible d'accéder à ta position. Choisis ta position manuellement.",
    this_is_profile_picture: "C'est ta photo de profil.",
    sure_delete_conversation: "Supprimer l'historique de conversation ?",
    failed_load_user: "Impossible de charger le profil utilisateur",
    please_register: "Inscris-toi",
    recover_it: "Récupérer", //we talk here about forgotten 'password' on login form
    not_a_member: "Pas encore membre ?",
    fail_block_user: "Impossible de bloquer l'utilisateur",
    user_reported_confirmation: "Merci pour ton signalement. Nous l'examinerons dès que possible",
    register_here: "S'inscrire Ici",
    options: {
        body: {
            slim: "Mince",
            average: "Moyen",
            athletic: "Athlétique",
            muscular: "Musclé",
            stocky: "Trapu"
        },
        position: {
            top: "Actif",
            more_top: "Plus actif",
            bottom: "Passif",
            more_bottom: "Plus passif",
            versatile: "Versatile"
        },
        hiv: {
            positive: "Positif",
            negative: "Negatif",
            undetectable: "Indétectable",
            prep: "PrEP",
            unknown: "Inconnu"
        },
        drugs: {
            yes: "'Oui",
            no: "Non",
            socially: "Quelquefois",
        }
    },
    Sunday: "Dimanche",
    Monday: "Lundi",
    Tuesday: "Mardi",
    Wednesday: "Mercredi",
    Thursday: "Jeudi",
    Friday: "Vendredi",
    Saturday: "Samedi",
    January: "Janvier",
    February: "Février",
    March: "Mars",
    April: "Avril",
    May: "Mai",
    June: "Juin",
    July: "Juillet",
    August: "Août",
    September: "Septembre",
    October: "Octobre",
    November: "Novembre",
    December: "Décembre",
    back: "Retour",
    report_harassment: "Harcèlement",
    report_fake: "Faux",
    report_spam: "Spam",
    report_under_age: "Mineur",
    report_other: "Autre",
    cookies_message: "Les cookies nous aident à fournir nos services. En utilisant nos services, tu acceptes notre utilisation des cookies.",
    learn_more: "En savoir plus",
    profile_is_deleted: "Ce profil a été supprimé",
    crop_photo: "Éditer photo",
    install_pwa_ios_message: "Installe BUDDY sur ton téléphone : tap <img src=\"/assets/img/iphone-share-btn.jpg\" style=\"height: 26px\" /> and then <strong>Add to Home Screen</strong>: <img style=\"height: 30px\" src=\"/assets/img/add-home-screen-en.png\" />",
    you_are_offline: "Il semble que tu sois hors ligne",
    show_map: "Carte",
    subscribe_to_newsletter: "Newsletter",
    emails_reminders: "Résumé par e-mail",
    daily: "Journalier",
    weekly: "Hebdomadaire",
    monthly: "Mensuel",
    never: "Jamais",
    "validation.imageable": "Format d'image non supporté. Télécharge des images aux formats JPG, PNG ou GIF.",
    user_blocked_confirmation: "L'utilisateur a été bloqué",
    search_users: "Pseudo",
    sure_delete_event: "Supprimer cet événement ?",

    home: {
        come_inside: 'Entre',
        content_removal : "Suppression de contenu",
        bad_boys_society: "Bad Boys Society",
        create_account: "Créer un compte",
        tagline: "BUDDY",
        fun: "Construire une meilleure application gay",
        login: "E-mail ou pseudo",
        password: "Mot de passe",
        log_in: "Connexion",
        remember_me: "Mémoriser.",
        forgot_password: "Mot de passe oublié ?",
        new_here: "Nouveau ?",
        sign_up: "S'inscrire",

        wants: "Montre ton côté coquin.",
        wants_desc: "Déjà expérimenté ou simplement curieux, deviens membre de la communauté BUDDY et explore tes envies. Tapote l'écran, et commence à discuter dans la foulée. Recherche avec des hashtags, pour pouvoir trouver plus rapidement les kinksters qui te correspondent le plus.<br><br>Décroche un date kinky plus vite que jamais.",

        videos: "Regarde et partage des vidéos.",
        videos_desc: "Regarde des tas de vidéos HOT de nos membres. Partage tes propres vidéos en privé ou sur ton profil public.<br><br>Ca n'a jamais été aussi FUN !",

        calendar: "Amusez-vous ensemble.",
        calendar_desc: "Crée des soirées privées dans notre calendrier. Dis-leur ce que tu veux, et fixe une date. Tu veux plus que ça ? Crée des groupes et fais toi de nouveaux amis.<br><br>Rencontre des kinksters qui te ressemblent.",

        everywhere: "Alors... C'est quoi ton kink ?",
        everywhere_desc: "Va sur notre site non censuré ou télécharge l'application BUDDY.<br><br>Rejoins-nous maintenant et teste par toi-même !",

        generation: "Bienvenu dans le Buddyvers",
        generation_desc: "Nous pensons vraiment que la meilleure façon de servir notre communauté, c'est d'accepter tout le monde. Contrairement à d'autres applis, les fonctionnalités les plus utiles sont gratuites. Pas de limite, pas de pubs relous. Nous voulons devenir la meilleure et la plus grande appli gay du monde kinky et fetichiste. Rejoins-nous maintenant et fais passer le mot.<br><br>Plus il y a de BUDDY... Et plus on s'amuse !",

        sign_up_now: "Rejoins-nous",

        company: "Entreprise",
        about_us: "À propos",
        blog: "Blog",
        help: "Aide",
        support: "Support facturation",

        legal: "Mentions légales",
        privacy: "Déclaration de confidentialité",
        terms: "Conditions d'utilisation",
        community_guidelines: "Règles de la communauté",
        usc: "18 U.S.C. 2257",
        imprint: "Impressum",

        languages: "Langues",
        follow_us: "Suis-nous"
    },

    home_old: {
        tagline: "Buddies<br/>&<br/>Benefits",
        easy_raw_free: "MEET MEN ON PREP",
        // responsible_dating: "Responsible bareback dating",
        home_text: `Come inside and meet gay guys near you.
            BUDDY is the first network
            for men on PrEP or TasP.`,
        join_start: "Join now and start dating immediately.",
        get_started: "Get started",
        screen_title1: "Easy.",
        screen_sub1: "On the hunt!",
        screen_text1: "Browse profiles, chat and send your videos with ease.",
        screen_title2: "FUN.",
        screen_sub2: "Pure and natural!",
        screen_text2: "No discussions, no judgement. Save your time. Just chat and meet.",
        screen_title3: "Free.",
        screen_sub3: "Join for free.",
        screen_text3: "Unlimited profile views, messages and pictures. BUDDY lets you have unlimited fun."
    },

    company: "Entreprise",
    legal: "Mentions légales",
    community_guidelines: "Règles de la communauté",
    social_media: "Réseaux sociaux",
    edit_your_photo: "Tu es magnifique !",
    complete_profile: "Remplir mon profil",
    add_more_photos: "Ajouter plus de photos",
    check_out_guys: "Jète un oeil aux Buddies",
    members_login: "Connexion membres ici",
    change_password: "changer mot de passe",
    create_your_event_plus: "Crée ton propre événement. Clique sur +",
    create_new_event: "Créer un nouvel événement :",
    create_event: "Créer un événement",
    create_your_club_plus: "Crée ton propre club. Clique sur +",
    create_new_club: "Créer un nouvel club :",
    create_club: "Créer un club",
    title: "Titre",
    date: "Date",
    time: "Heure",
    add_event_details: "Ajouter des détails :",
    event_description: "Description de l'événement",
    club_description: 'Description',
    club_description_placeholder: 'En quoi consiste votre club ?',
    joined_to_club: "a rejoint",
    left_to_club: "est parti",
    private: "Private",
    public: "Public",
    non_commercial: "non-commercial",
    commercial: "commercial",
    add_tags_optional: "Ajouter des tags (optionnel)",
    select_address: "Sélectionner une adresse",
    location_details: "Détails de position (optionnel)",
    location_example: "(eg: my flat, venue name)",
    full_address: "Full address",
    city_only: "Only city",
    event_choose_photos: "Choisis des images pour ton événement",
    club_choose_photos: 'Choisissez des images pour votre club',
    display: "montrer :",
    alternative: '',
    hot: "photo sexy (optionnel)",
    preview: 'image sans risque',
    for_censored_app: "pour application censurée",
    visible_only_uncensored_website: "visible uniquement sur le site web non censuré",
    preview_picture: "Image d'aperçu",
    submit_event: "Envoyer",
    event_address: "Adresse de l'événement",
    club_address: 'Ville',
    please_select_preview_picture: "Choisis une image d'aperçu",
    set_preview_picture: "Choisir comme image d'aperçu",
    event_successfully_added: "Ton événement a bien été ajouté",
    event_successfully_updated: "Votre événement a été mis à jour avec succès.",
    no_events_around: "Aucun événement aux alentours",
    no_more_event_around: "Pas d'autre événement aux alentours",
    club_successfully_added: 'Ton club a bien été ajouté',
    no_clubs_around: 'Aucun clubs aux alentours',
    no_more_club_around: "Pas d'autre clubs aux alentours",
    edit: "Éditer",
    recipient_will_not_see_you: "Le destinataire ne verra pas ton vrai profil.",
    public_videos: "Vidéos publiques",
    send: "Envoyer",
    event_choose_videos: "Choisis des vidéos pour ton événement",
    delete_video: "Supprimer vidéo",
    add_video: "Ajouter vidéo",
    videos: "Vidéos",
    play_video: "Lire vidéo",
    video_uploaded_processing: "Ta vidéo a bien été téléchargée et est maintenant en cours de traitement. Nous t'enverrons une notification dès qu'elle sera prête.",
    video_processed: "Ta vidéo est prête à être utilisée.",
    video_message: "Message vidéo",
    sure_delete_photo: "Supprimer cette photo ?",
    sure_delete_video: "Supprimer cette vidéo ?",
    too_hot: "Too hot",
    notifications: "Notifications",
    push_notifications: "Notifications push",
    help: "Aide",
    profile: "Profil",
    user_blocked: "Vous avez bloqué cet utilisateur ou il vous a bloqué.",
    open_blocked_users: "Ouvrir la liste des utilisateurs bloqués",
    faq: "FAQ",
    support_chat: "Chat d'assistance",
    click_here_tutorials: "Clique ici pour des tutoriels",
    send_direct_message: "Envoie-nous un message directement",
    app: "App",
    security: "Sécurité",
    notification_sound: "Son de notification",
    deactivate_my_profile: "Désactiver mon profil",
    deactivate_or_delete_my_profile: "Désactiver ou supprimer mon profil",
    customize_sharing_links: "Personnaliser les liens de partage",
    delete_all_sharing_links: "Supprimer tous les liens de partage",
    delete_all: "Supprimer tout",
    deactivate_account: "Désactiver mon compte",
    taking_break_buddy: "Tu fais une pause de BUDDY ?",
    deactivate_text_description: "Désactive ton profile et disparais complètement du radar et de la recherche.",
    deactivate: "Désactiver",
    delete_profile_text: "Si tu veux quitter BUDDY pour de bon, {0} pour supprimer ton profil. Ceci est permanent et ne peut pas être annulé, ce qui veut dire que tu devras recréer un profil quand tu reviendras. Rappelle-toi, every buddy needs some BUDDY",
    click_here: "clique ici",
    are_you_sure_deactivate_profile: "Es-tu certain de vouloir désactiver ton profil ?",
    inactive_profile: "Profil inactif",
    account_is_deactivated: 'Ton magnifique profil BUDDY est actuellement inactif. <br /> Clique sur "Activer" pour revenir.',
    activate: "Activer",
    leave: "Quitter",
    profile_is_deactivated: "Ce profil est actuellement désactivé",
    prep_safer_use: "PrEP, TasP, STD, Safer use",
    information_education: "Information & Education",
    prep_chat: "PrEP Chat",
    channel_prep_questions: "Channel for 1:1 PrEP questions",
    censored_event_title: "***Content Warning***",
    censored_event_description: "***This event may contain sensitive material*** <br /><br />Your media settings are configured to warn you about sensitive material. <br />To view it, you need to change your selection in your safety settings",
    censored_content_warning: "Tes paramètres médias sont configurés pour te prévenir de tout contenu sensible. <br /><br />Pour voir ça, tu dois changer ta sélection dans tes paramètres de sécurité.",
    change_settings: "Changer Paramètres",
    show_more: "Voir plus...",
    display_sensitive_events: "APP: événements sensibles",
    display_sensitive_media: "APP: médias sensibles",
    display_sensitive_media_web: "Web: médias sensibles",
    tiles: "Tuiles",
    list: "Liste",
    filter: "Filtre",
    pics: "Images",
    age: "Âge",
    new: "Nouveau",
    ok: "OK",
    taps: "Taps",
    visitors: "Visiteurs",
    visited: "Visité",
    no_visitors: "Aucun visiteur pour l'instant",
    no_more_visitors: "Aucun autre visiteur",
    no_visited: "Aucune visite pour l'instant",
    no_more_visited: "Aucune autre visite",
    no_taps: "Aucun tap",
    no_more_taps: "Aucun autre tap",

    discreet_mode: "Invisible",
    discreet_mode_on: "Mask Mode (ON)",
    discreet_mode_off: "Mask Mode (OFF)",

    hide_profile_completely: "Cacher profile complètement",
    upgrade_to_pro: "Passer à la version PRO",
    upgrade_to: "Passer à",
    upgrade_now: "Mettre à niveau maintenant",
    upgrade: "Mettre à niveau",
    click_here_to_upgrade: "Clique ici pour mettre à niveau",
    click_here_to_cancel: "Clique ici pour annuler",
    pro: "PRO",
    cancel_pro: "Annuler PRO",
    thank_you_for_being_a_pro: "Merci d'être un Buddy PRO",
    successful_pro_upgrade: "Tu es maintenant un Buddy PRO !",
    failed_pro_upgrade: "Oups... Une erreur s'est produite",
    we_hope_you_enjoyed_pro: "On espère que tu as aimé Buddy PRO",

    delete_this_message: "Supprimer ce message ?",
    delete: "Supprimer",
    removed: "supprimé",

    pro_slides_1_title: "Invisible",
    pro_slides_1_description: "avec Mode Masqué",
    pro_slides_2_title: "Annuler Messages",
    pro_slides_2_description: "et voir s'il a lu<br />ton message",
    pro_slides_3_title: "Plus de Filtres",
    pro_slides_4_title: "Illimité",
    pro_slides_4_description: "favoris, blocages, visiteurs,<br />images et vidéos publiques",
    pro_slides_5_title: "Plus de Fun",
    pro_slides_5_description: "voir toutes les images et vidéos",

    notifications_button: 'Activer les notifications',
    splash_notifications_title: 'Restez informé',
    splash_notifications_description: 'Veuillez activer les notifications pour recevoir des messages et des alertes de vos buddies',

    splash_blocks_title: "Blocages illimités",
    splash_blocks_description: "pour des blocages illimités, passer à",
    splash_favorites_title: "Favoris illimités",
    splash_favorites_description: "pour des favoris illimités, passer à",
    splash_mask_title: "Invisible",
    splash_mask_description: "avec Invisible passer à",
    splash_censored_title: "Voir plus",
    splash_censored_description: "pour du contenu illimité passer à",
    splash_visitors_title: "qui m'a consulté",
    splash_visitors_description: "pour voir tous vos visiteurs passer à",
    splash_filters_title: "Plus de filtres",
    splash_filters_description: "Pour plus de filtres, passer à",
    splash_media_title: "Images et vidéos publiques illimitées",
    splash_media_description: "pour des images/vidéos publiques illimitées passer à",
    splash_deletemsg_title: "Supprimer un message",
    splash_deletemsg_description: "pour supprimer un message passer à",
    splash_change_settings_title: "Tes paramètres médias sont configurés pour te prévenir de tout contenu sensible.",
    splash_change_settings_description: "Pour voir ça, tu dois changer ta sélection dans tes paramètres de sécurité.",
    splash_events_title: "Plus d'événements",
    splash_events_description: "Pour plus d'événements, passer à",

    pro_upgrade_message_desktop: "Les abonnements sont renouvelés automatiquement sauf s'ils sont annulés 24 heures avant la fin de la période en cours.<br>Voir <a href='\http://cs.segpay.com\'>SEGPAYEU.COM</a>, notre agent commercial autorisé. Les frais facturés seront indiqués sur ton relevé bancaire par <a href=\"http://cs.segpay.com\">SEGPAYEU.COM*BUDDY</a>.",
    pro_upgrade_message_mobile: "Les abonnements sont renouvelés automatiquement sauf s'ils sont annulés 24 heures avant la fin de la période en cours.",
    payment_blocked: "La demande de paiement est en cours de traitement.",
    you_cant_send_messages_to_this_user: "Tu ne peux pas envoyer de message à cet utilisateur.",

    events: {
        report: {
            title: "Signaler Événement",
            wrong_type: "Mauvaise catégorie",
            illegal: "Illégal",
        },
        type: {
            friends: "Amis",
            fun: "Date",
            bang: "Chill",
            chemsfriendly: "chemsfriendly",
            required: "Choisis une catégorie",
        },
        date: {
            today: "aujourd'hui",
            tomorrow: "demain",
            pick_date: "date"
        },
        link_my_profile: "Lier mon profil",
        not_found: "Événement introuvable",
        report_success: "Merci d'avoir signalé cet événement. Nous l'examinerons dès que possible.",
        new_event: "Nouvel événement",
        new_bang: "Nouveau bang",
        my_events: "Mes événements",
        publish: "Publier",
        select_type: "Quel type d'événement aimerais-tu créer ?",
        about_guide: "événements publics pour tout le monde (fêtes, festivals, communauté)",
        about_fun: "trouver un buddy pour des activités privées",
        about_bang: "organiser des événements privés en groupe",
        invitation_only_event: "sur invitation (événement privé)",
        please_add_favourite_buddies_first: "Ajoute d'abord tes buddies favorites",
        accept: "Accepter",
        decline: "Décliner",
        invited: "Invité",
        invite: "Inviter",
    },

    clubs: {
        admin: 'Admin',
        invites: 'Invites',
        member: 'Member',
        nearby: 'Nearby',
        more_clubs: 'Plus de clubs',
        hide_club_admin: "Masquer l'admin du club",
        report: {
            title: 'Signaler Club',
            wrong_type: "Mauvaise catégorie",
            illegal: "Illégal",
        },
        type: {
            discover: 'Découvrir',
            my_clubs: 'Mes clubs',
            chemsfriendly: "chemsfriendly",
            required: "Choisis une catégorie",
        },
        date: {
            today: "aujourd'hui",
            tomorrow: "demain",
            pick_date: "date"
        },
        not_found: "Club introuvable",
        report_success: "Merci d'avoir signalé cet club. Nous l'examinerons dès que possible.",
        new_club: 'Nouveau club',
        my_clubs: 'Mes clubs',
        publish: "Publier",
        invitation_only_club: "sur invitation (club privé)",
        write_to_support_to_open_club: "Écris au support si tu souhaites modifier la confidentialité de ce club",
        please_add_favourite_buddies_first: "Ajoute d'abord tes buddies favorites",
        accept: "Accepter",
        decline: "Décliner",
        invited: "Invité",
        invite: "Inviter",
    },

    payment: {
        coming_soon: "Bientôt disponible",
        month: "par mois",
        one_month: "mois",
        three_months: "mois",
        twelve_months: "mois",
        your_promotion_code: "Ton code promotionnel",
        please_select_payment_option: "Sélectionne une option de paiement.",
        use_promo_code: "Utiliser un Code PROmotionnel",
        credit_card: "Carte de crédit",
        alternative_payments: "Autres moyens de paiement",
        renews_automatically_until_cancelled: "Renouvellement automatique jusqu'à annulation.",
        active_until: "Ton statut PRO est actif jusqu'au",
        one_time: "Une fois",
        no_need_to_cancel: "(Pas besoin d'annuler !)",
        upgrade: {
            one_month: "Mise à niveau pour 1 Mois",
            three_months: "Mise à niveau pour 3 Mois",
            twelve_months: "Mise à niveau pour 12 Mois",
        },
        upgrade_paypal: {
            one_month: "PayPal à niveau pour 1 Mois",
            three_months: "PayPal à niveau pour 3 Mois",
            twelve_months: "PayPal à niveau pour 12 Mois",
        },
        send: "Envoyer",
        thank_you: "Merci !",
        return_to_buddy: "Retour à BUDDY",
        paypal: {
            message: "<p>Entre ton adresse e-mail PayPal.</p><br /> <p>On t'enverra un lien PayPal à cette adresse.</p><br /> <p>Une fois le paiement reçu, on boostera ton profil Buddy.</p>",
            successMessage: "<p>Nous avons bien reçu ta demande de mise à niveau.</p><br /><p>Nous t'enverrons bientôt un lien PayPal.</p><br /><p>Après réception du paiement, laisse-nous un peu de temps <br /> pour effectuer ta mise à niveau.</p> <br /><p>Nous le faisons à la main ! ✊🏻💦</p>"
        },
        features: {
            unlock_filters : "Débloquer tous les filtres",
            be_invsble: "Être invisible",
            see_all_who_viewed_me: "Voir tous ceux qui m'ont consulté",
            remove_messages: "Supprimer les messages",
            make_notes_on_profile: "Prendre des notes sur les profils",
            unlimited_favorites: "Favoris illimités",
            view_hot_medias: "Voir les médias XXX dans l'application",
            see_if_your_message_has_been_read: "Vérifier si votre message a été lu",
            see_wh_marked_you_favorite: "Voir qui vous a marqué comme favori",
            hide_profile_visits: "Masquer les visites de profil"
        }
    },

    uploadVideos: {
        error: {
            lowDuration: "La durée de la vidéo doit être supérieure à 1 seconde.",
            highDuration: "La durée de la vidéo doit être inférieure à 15 minutes.",
        },
    },

    rush: {
        running_for_x_days: "En cours depuis {days} jour(s)",
        stars_and_strips_upgrade: "Stars and Strips. Passe à",
        announce: "<span>Salut les Buddies,</span><span>les créateurs de Buddy vous ont concocté une nouveauté.</span><span>Les {0} sont des petites apps inclues dans BUDDY, utiles et amusantes,</span><span>amusez-vous bien et restez curieux !</span>",
        how_to: {
            title: "RUSH - Mode d'emploi...",
            create: "Crée ton strip",
            name: "Donne un nom à ton strip",
            media: "Sélectionne une image ou écris un texte",
            publish: "Publie ton strip et ajoute plus de contenu",
        },
        welcome: {
            title: "Bienvenue sur RUSH",
            story: {
                title: "Ta propre histoire",
                description: "Ajoute des Photos à ton strip et montre-les à tous tes buddies.",
            },
            post: {
                title: "Poste tous les jours.",
                description: 'Make the "Fait durer le "Rush" plus longtemps et obtiens plus d\'applaudissements.',
            },
            applause: {
                title: "Plus d'applaudissements ?!",
                description: "Ca te permet d'obtenir une tuile d'aperçu plus grande. Cela veut dire plus de vues de buddies !",
            },
            attention: {
                title: "Attention !",
                description: "S'il n'y a pas de nouvelle image dans les 24 heures, ton strip disparaît. Le 'Rush' est terminé.",
            },
        },
    },
    sure_unblock_user: "Débloquer ce profil ?",

    party_on_buddies1: "PARTY ON,",
    party_on_buddies2: "BUDDIES!",
    party_on_text1: "There is something new in the Buddyverse. Check out the new \"Guide\" section in our calendar and find parties and events nearby.",
    party_on_text2: "After two years it's about time we go out again and have fun! Let's support event organisers together and rock the party.",

    are_you_sure_you_want_to_delete_all_sharing_links: "Voulez-vous vraiment supprimer tous les liens de partage?",
    all_links_will_be_deactivated: "Tous les liens seront désactivés.",
    all_sharing_links_deleted_successfully: "Tous les liens de partage ont été supprimés avec succès",
    this_is_your_sharing_code: "Voici ton lien de partage (clique pour copier)",
    share_your_selected_videos: "Partage tes vidéos sélectionnées avec<br>des mecs qui ne sont pas encore sur Buddy.",
    send_via_whatsapp: "Partage via Whatsapp",
    tap_on_the_videos_you_want_to_share: "Tape sur les vidéos que tu veux partager",
    cancel_share: "Annuler",
    share_now: "Partager",
    status:"Statut",
    you_need_to_be_a_pro_for_editing:"Vous devez être un <strong>PRO</strong> pour l'édition",
    expire_at_date:"Expire à la date",
    expire_at_time:"Expire à l'heure",
    views_limit:"Limite de vues",
    you_dont_have_any_links:"Vous n'avez aucun lien",
    link_settings_saved:"Paramètres de lien enregistrés",
    can_not_get_sharing_links:"Impossible d'obtenir des liens de partage",
    copied_to_clipboard: "copié dans le presse-papier",
    share_whatsapp_test: "Voici le lien vers ma vidéo sur buddy.net:",
    share_videos: 'Partager des vidéos',
    accept_all: 'Accepter tout',
    no_messages : 'Pas de messages',
    you : 'Tu',
    has: 'a',
    have: 'as',
    joined: 'rejoint',
    left: 'quitté',
    web_push_notifications: 'Notifications push Web',
    modal_pro_upgrade_description : 'Profite de cette fonction et de bien d\'autres si tu passes à la version PRO.',
    modal_pro_visit_upgrade_description : 'Masque ta visite sur ce profil avec PRO',
    note : 'Note',
    note_textarea_placeholder : "Ajouter des informations personnelles sur ce profil...",
    who_marked_me_favorite : "Qui m'a marqué comme favori",
    cancel_failed: "L'annulation a échoué, réessayez",
    subscription_canceled: "Abonnement annulé",
    confirm_cancel: "Voulez-vous vraiment annuler l'abonnement ?",
    cancel_subscription: "Annuler l'abonnement"
}
